var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "37pt",
    height: "37pt",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1337"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.784314%,46.666667%,74.117647%)",
      fillOpacity: 1
    },
    d: "M 31.605469 3.855469 L 5.394531 3.855469 L 7.707031 30.0625 L 18.5 33.144531 L 29.292969 30.0625 Z M 31.605469 3.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(1.176471%,60.784314%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 18.5 6.167969 L 18.5 30.757812 L 27.132812 28.289062 L 29.058594 6.167969 Z M 18.5 6.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 25.515625 10.019531 L 18.5 10.019531 L 18.5 13.105469 L 22.277344 13.105469 L 22.046875 16.1875 L 18.5 16.1875 L 18.5 19.269531 L 21.890625 19.269531 L 21.660156 22.738281 L 18.5 23.820312 L 18.5 27.054688 L 24.589844 25.050781 L 25.128906 16.1875 Z M 25.515625 10.019531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,93.333333%,93.333333%)",
      fillOpacity: 1
    },
    d: "M 18.5 10.019531 L 18.5 13.105469 L 11.640625 13.105469 L 11.410156 10.019531 Z M 14.953125 16.1875 L 15.109375 19.269531 L 18.5 19.269531 L 18.5 16.1875 Z M 15.261719 20.8125 L 12.179688 20.8125 L 12.410156 25.050781 L 18.5 27.054688 L 18.5 23.820312 L 15.339844 22.738281 Z M 15.261719 20.8125 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.d65d0a4a7a31313beec582b56b731750.svg";
export { ForwardRef as ReactComponent };